import type { CodeBlockPluginOptions } from '@atlaskit/editor-plugin-code-block/types';

interface Props {
	options: never;
}

export function codeBlockPluginOptions({}: Props): CodeBlockPluginOptions {
	return {
		allowCopyToClipboard: true,
		useLongPressSelection: false,
		allowCompositionInputOverride: false,
	};
}
